import {post} from '../utils'
import {getActiveChannel} from "../authentication/utils";

export default host => (channelId, userId) =>
  post(`${host}/channels/${channelId}/user/${userId}/completeForm`);